import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppConstants } from '../../app.constants';

@Component({
  selector: 'time-input',
  standalone: true,
  imports: [
    FormsModule
  ],
  templateUrl: './time-input.component.html',
  styleUrl: './time-input.component.scss'
})
export class TimeInputComponent implements OnInit {
  _value: string;

  hours: string;
  minutes: string;
  seconds: string;

  @Input()
    get value() {
      return this._value;
    }

  @Output() valueChange = new EventEmitter();
  set value(value) {
    this._value = value;
    this.valueChange.emit(this._value);
  }

  ngOnInit(): void {
    const [hours, minutes, seconds] = this.value?.length ?
      this.value.split(':') :
      [];

    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;
  }

  validateInput(inputEl: HTMLInputElement) {
    const inputValue = inputEl.value.substring(0, 2);
    const inputName = inputEl.name;

    if (
      (inputName === AppConstants.TIMER_HOURS_INPUT && Number(inputValue) > Number(AppConstants.CUSTOM_TIMER_MAX_HOURS)) ||
      Number(inputValue) > Number(AppConstants.CUSTOM_TIMER_MAX_MINUTES)
    ) {
      inputEl.value = inputName === AppConstants.TIMER_HOURS_INPUT ?
        AppConstants.CUSTOM_TIMER_MAX_HOURS :
        AppConstants.CUSTOM_TIMER_MAX_MINUTES;
    }
    else if (Number(inputValue) < 0 || inputValue === '') {
      inputEl.value = '';
    }
    else {
      inputEl.value = inputValue;
    }

    this.updateValue(inputEl.value, inputName);
  }

  handleBlur(inputEl: HTMLInputElement) {
    if (inputEl.value && Number(inputEl.value) < 10) {
      inputEl.value = inputEl.value.padStart(2, '0');
    }

    this.updateValue(inputEl.value, inputEl.name);
  }

  private updateValue(newValue: string, inputName: string) {
    switch(inputName) {
      case AppConstants.TIMER_HOURS_INPUT:
        this.hours = newValue;
        break;
      case AppConstants.TIMER_MINUTES_INPUT:
        this.minutes = newValue;
        break;
      case AppConstants.TIMER_SECONDS_INPUT:
        this.seconds = newValue;
        break;
    }

    if (
      (!this.hours || !Number(this.hours)) &&
      (!this.minutes || !Number(this.minutes)) &&
      (!this.seconds || !Number(this.seconds))
    ) {
      this.value = null;
    }
    else {
      const time = `${ this.hours || '00' }:${ this.minutes || '00' }:${ this.seconds || '00' }`;
      this.value = time;
    }
  }
}
